<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="mb-1 block text-left text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <div class="relative rounded-md">
      <input
        :type="type"
        :name="name"
        :autocomplete="autocomplete"
        :class="[
          'block w-full rounded-md border border-background-fg/8 text-base font-semibold focus:outline-none', // Font size set at >14px (text-base) so no zoom on mobile when focused
          hasError
            ? 'border-error text-error placeholder:text-error focus:border-error focus:ring-error'
            : 'focus:border-primary focus:ring-primary',
        ]"
        :placeholder="placeholder"
        :value="inputValue"
        :aria-invalid="hasError"
        enterKeyHint="done"
        :disabled="disabled"
        :maxlength="maxlength"
        @change="handleChange"
        @blur="handleBlur"
      />
    </div>
    <template v-if="hasError">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = withDefaults(
  defineProps<{
    type?: string
    name: string
    label?: string
    placeholder?: string
    disabled?: boolean
    maxlength?: number
    autocomplete?: string
  }>(),
  {
    modelValue: "",
    type: "text",
    label: "",
    placeholder: "",
    disabled: false,
    maxlength: undefined,
  }
)

const name = toRef(props, "name")

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(name, undefined, {
  initialValue: undefined,
})

const hasError = computed(
  () => !!errorMessage.value && meta.touched
)
</script>
